import { Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import Index from "pages/FileUpload";
import ListingPage from "pages/Listing";

// Auth Protected Routes (Authentication Required)
const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/index", component: <Dashboard /> },
  { path: "/folderUpload", component: <Index /> },
  { path: "/listing", component: <ListingPage /> },
  { path: "*", component: <Navigate to="/dashboard" replace /> },
];

// Public Routes (No Authentication Required)
const publicRoutes = [
  { path: "/", component: <Navigate to="/login" replace /> },
  { path: "/login", component: <Login /> },
  { path: "*", component: <Navigate to="/login" replace /> },
];

export { authProtectedRoutes, publicRoutes };